// extracted by mini-css-extract-plugin
export default {"subscribeForm-container":"Index_subscribeForm-container__YboLC"};